var map = {
	"./sinWave-Black/sinWave-Large-Black.png": [
		1397,
		4
	],
	"./sinWave-Black/sinWave-Medium-Black.png": [
		1398,
		5
	],
	"./sinWave-Black/sinWave-Medium-Black1.png": [
		1399,
		6
	],
	"./sinWave-Black/sinWave-Small-Black.png": [
		1400,
		7
	],
	"./sinWave-Black/sinWave-l0-Black.png": [
		1401,
		8
	],
	"./sinWave-Black/sinWave-l1-Black.png": [
		1402,
		9
	],
	"./sinWave-Black/sinWave-l2-Black.png": [
		1403,
		10
	],
	"./sinWave-Black/sinWave-l3-Black.png": [
		1404,
		11
	],
	"./sinWave-Black/sinWave-l4-Black.png": [
		1405,
		12
	],
	"./sinWave-Black/sinWave-l5-Black.png": [
		1406,
		13
	],
	"./sinWave-DarkBlue/sinWave-Large-DarkBlue.png": [
		1407,
		14
	],
	"./sinWave-DarkBlue/sinWave-Medium-DarkBlue.png": [
		1408,
		15
	],
	"./sinWave-DarkBlue/sinWave-Small-DarkBlue.png": [
		1409,
		16
	],
	"./sinWave-DarkBlue/sinWave-l0-DarkBlue.png": [
		1410,
		17
	],
	"./sinWave-DarkBlue/sinWave-l1-DarkBlue.png": [
		1411,
		18
	],
	"./sinWave-DarkBlue/sinWave-l2-DarkBlue.png": [
		1412,
		19
	],
	"./sinWave-DarkBlue/sinWave-l3-DarkBlue.png": [
		1413,
		20
	],
	"./sinWave-DarkBlue/sinWave-l4-DarkBlue.png": [
		1414,
		21
	],
	"./sinWave-DarkBlue/sinWave-l5-DarkBlue.png": [
		1415,
		22
	],
	"./sinWave-Green/sinWave-Large-Green.png": [
		1416,
		23
	],
	"./sinWave-Green/sinWave-Medium-Green.png": [
		1417,
		24
	],
	"./sinWave-Green/sinWave-Small-Green.png": [
		1418,
		25
	],
	"./sinWave-Green/sinWave-l0-Green.png": [
		1419,
		26
	],
	"./sinWave-Green/sinWave-l1-Green.png": [
		1420,
		27
	],
	"./sinWave-Green/sinWave-l2-Green.png": [
		1421,
		28
	],
	"./sinWave-Green/sinWave-l3-Green.png": [
		1422,
		29
	],
	"./sinWave-Green/sinWave-l4-Green.png": [
		1423,
		30
	],
	"./sinWave-Green/sinWave-l5-Green.png": [
		1424,
		31
	],
	"./sinWave-LightBlue/sinWave-Large-LightBlue.png": [
		1425,
		32
	],
	"./sinWave-LightBlue/sinWave-Medium-LightBlue.png": [
		1426,
		33
	],
	"./sinWave-LightBlue/sinWave-Small-LightBlue.png": [
		1427,
		34
	],
	"./sinWave-LightBlue/sinWave-l0-LightBlue.png": [
		1428,
		35
	],
	"./sinWave-LightBlue/sinWave-l1-LightBlue.png": [
		1429,
		36
	],
	"./sinWave-LightBlue/sinWave-l2-LightBlue.png": [
		1430,
		37
	],
	"./sinWave-LightBlue/sinWave-l3-LightBlue.png": [
		1431,
		38
	],
	"./sinWave-LightBlue/sinWave-l4-LightBlue.png": [
		1432,
		39
	],
	"./sinWave-LightBlue/sinWave-l5-LightBlue.png": [
		1433,
		40
	],
	"./sinWave-Red/sinWave-Large-Red.png": [
		1434,
		41
	],
	"./sinWave-Red/sinWave-Medium-Red.png": [
		1435,
		42
	],
	"./sinWave-Red/sinWave-Small-Red.png": [
		1436,
		43
	],
	"./sinWave-Red/sinWave-l0-Red.png": [
		1437,
		44
	],
	"./sinWave-Red/sinWave-l1-Red.png": [
		1438,
		45
	],
	"./sinWave-Red/sinWave-l2-Red.png": [
		1439,
		46
	],
	"./sinWave-Red/sinWave-l3-Red.png": [
		1440,
		47
	],
	"./sinWave-Red/sinWave-l4-Red.png": [
		1441,
		48
	],
	"./sinWave-Red/sinWave-l5-Red.png": [
		1442,
		49
	],
	"./sinWave-White/sinWave-Large-White.png": [
		1443,
		50
	],
	"./sinWave-White/sinWave-Medium-White.png": [
		1444,
		51
	],
	"./sinWave-White/sinWave-Small-White.png": [
		1445,
		52
	],
	"./sinWave-White/sinWave-l0-White.png": [
		1446,
		53
	],
	"./sinWave-White/sinWave-l1-White.png": [
		1447,
		54
	],
	"./sinWave-White/sinWave-l2-White.png": [
		1448,
		55
	],
	"./sinWave-White/sinWave-l3-White.png": [
		1449,
		56
	],
	"./sinWave-White/sinWave-l4-White.png": [
		1450,
		57
	],
	"./sinWave-White/sinWave-l5-White.png": [
		1451,
		58
	],
	"./sinWave-Yellow/sinWave-Large-Yellow.png": [
		1452,
		59
	],
	"./sinWave-Yellow/sinWave-Medium-Yellow.png": [
		1453,
		60
	],
	"./sinWave-Yellow/sinWave-Small-Yellow.png": [
		1454,
		61
	],
	"./sinWave-Yellow/sinWave-l0-Yellow.png": [
		1455,
		62
	],
	"./sinWave-Yellow/sinWave-l1-Yellow.png": [
		1456,
		63
	],
	"./sinWave-Yellow/sinWave-l2-Yellow.png": [
		1457,
		64
	],
	"./sinWave-Yellow/sinWave-l3-Yellow.png": [
		1458,
		65
	],
	"./sinWave-Yellow/sinWave-l4-Yellow.png": [
		1459,
		66
	],
	"./sinWave-Yellow/sinWave-l5-Yellow.png": [
		1460,
		67
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 86;
module.exports = webpackAsyncContext;